import AuthService from './AuthService';
import StorageService from './StorageService';
let instance = null;
let auth = new AuthService();
let SS = new StorageService();

export default class RoutingService {
	constructor() {
		if (instance) {
			return instance;
		}
		this.currentTenant = null;
		this.currentApplication = null;
		this.currentUser = auth.decodedToken;
		this.currentEnv = null;
		this.lastLocation = null;
		instance = this;
	}
	//TODO move this into it's own service
	setNotificationSystem(notificationSystem) {
		this.notificationSystem = notificationSystem;
	}

	showNotification(notification) {
		this.notificationSystem.addNotification(notification);
	}

	showSuccess(msg) {
		this.showNotification({
			message: msg ? msg : 'Success!',
			level: 'success',
			position: 'tr'
		});
	}

	showError(msg) {
		this.showNotification({
			message: 'Error: ' + msg,
			level: 'error',
			position: 'tr'
		});
	}

	smartError(err) {
		if (err && typeof err === 'object' && err.response && err.response.data) {
			let { status, message } = err.response.data;
			this.showError(message + '. Status Code ' + status);
		} else {
			if (err && err.response && err.response.data && typeof err.response.data === 'string') {
				this.showError(err.response.data);
			} else if (err && err.message && typeof err.message === 'string') {
				this.showError(err.message);
			} else if (err && typeof err === 'string') {
				this.showError(err);
			} else {
				this.showError('Error: Something went wrong.');
			}
		}
	}

	showInfo(msg) {
		this.showNotification({
			message: msg,
			level: 'info',
			position: 'tr'
		});
	}

	setHistory(history) {
		instance.history = history;
	}

	goToRoute(route) {
		instance.history.push(route);
	}

	getCurrentTenant() {
		return this.currentTenant;
	}

	getCurrentApplication() {
		return this.currentApplication;
	}

	getCurrentConfiguration() {
		return this.currentConfiguration;
	}

	getCurrentEnvironment() {
		return this.currentEnv;
	}

	getCurrentUser() {
		return this.currentUser;
	}

	getLastLocation() {
		return this.lastLocation;
	}

	//TODO layer in security roles etc into this
	getCurrentNavItems() {
		let user = this.getCurrentUser() || {};
		let navItems = [];
		if (user) {
			let group1 = ['app-builder', 'tenants'];
			let group2 = ['app-builder', 'tenants', 'tenant-management'];
			let group3 = ['app-builder', 'tenants', 'tenant-management', 'connections', 'endpoints', 'entities'];
			let group4 = ['app-builder', 'tenants', 'tenant-management', 'modules']; //'dashboard', 'activity', 'composer',
			if (auth.isAnyAdmin() && instance.getCurrentTenant() !== null) {
				navItems.push('manage');
				navItems.push('manage-users');
			} else if (auth.hasPlatformRole()) {
				navItems.push('manage');
				navItems.push('manage-users');
			}
			if (this.getCurrentTenant() && this.getCurrentEnvironment() && !this.getCurrentApplication()) {
				navItems = navItems.concat(group3); //im inside of a tenant and an environment
				if (user.platformAdministrator || user.hasValidRoleForCurrentTenant) {
					navItems.push('manage-sandboxes');
				}
				if (user.platformAdministrator || user.hasValidRoleForCurrentTenantAndMigrationAccess) {
					navItems.push('migrations');
				}
			} else if (this.getCurrentTenant() && this.getCurrentEnvironment() && this.getCurrentApplication()) {
				navItems = navItems.concat(group4); //im inside of a tenant an environment & an application
			} else if (this.getCurrentTenant() && !this.getCurrentEnvironment()) {
				navItems = navItems.concat(group2); //im just inside of a tenant
			} else {
				navItems = navItems.concat(group1); //im nowhere yet
			}
			if (!auth.hasPlatformRole()) {
				navItems.splice(navItems.indexOf('app-builder'), 1);
			}
		}
		return navItems;
	}

	setLastLocation(location) {
		this.lastLocation = location;
	}

	setCurrentTenant(tenant) {
		this.currentTenant = tenant;
		this.currentApplication = null;
		SS.setUserData('current-tenant', tenant);
		SS.setUserData('current-application', null);
	}

	setCurrentApplication(app) {
		this.currentApplication = app;
		SS.setUserData('current-application', app);
	}

	setCurrentConfiguration(config) {
		this.currentConfiguration = config;
		SS.setUserData('current-config', config);
	}

	setCurrentEnvironment(env) {
		this.currentEnv = env;
		SS.setUserData('current-sandbox', env);
	}
}



// WEBPACK FOOTER //
// ./src/services/RoutingService.js